import React, { PureComponent } from 'react';
import axios from 'axios';
import Select from 'react-select-v2';
import Classnames from 'classnames';
import Modal from 'react-responsive-modal';
import Linkify from 'react-linkify';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactGA from 'react-ga';

import './App.css';
import {
  Calendar,
  momentLocalizer,
} from 'react-big-calendar';
import moment from 'moment-timezone';
import Checkbox from 'rc-checkbox';
import chroma from 'chroma-js';
import 'rc-checkbox/assets/index.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';

moment.tz.setDefault(moment.tz.guess());
console.debug('moment guess Timezone: ' + moment.tz.guess());

const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
console.debug('itnlTimezone: ' + TIMEZONE);

const EUROPE = '(EU)';
const US = '(US)';

const localizer = momentLocalizer(moment);


const componentDecorator = (href, text, key) => (
  <a href={href} key={key} target="_blank" rel="noopener noreferrer">
    {text}
  </a>
);

// Initialize the Font Awesome library
library.add(faInfoCircle);

const OUTLOOK_COLORS = {
  preset0: '#F07D88',
  preset1: '#FF8C00',
  preset2: '#FECB6F',
  preset3: '#FFF100',
  preset4: '#5FBE7D',
  preset5: '#33BAB1',
  preset6: '#A3B367',
  preset7: '#55ABE5',
  preset8: '#A895E2',
  preset9: '#E48BB5',
  preset10: '#B9C0CB',
  preset11: '#4C596E',
  preset12: '#ABABAB',
  preset13: '#666666',
  preset14: '#474747',
  preset15: '#910A19',
  preset16: '#CE4B28',
  preset17: '#A47332',
  preset18: '#B0A923',
  preset19: '#026802',
  preset20: '#1C6367',
  preset21: '#5C6A22',
  preset22: '#254069',
  preset23: '#562685',
  preset24: '#80275D',
};

const CATEGORY_INFO = {
  'Event/Conference': 'Events team functions (speaking engagements, conferences, WT hosted events, client events)',
  'Trade/Filing/Earnings': 'WETF trading windows, filings, earnings calls, dividend payouts',
  'Public Company Dates': 'WETF trading windows, filings, earnings calls, dividend payouts',
  'Public Co. Dates': 'WETF trading windows, filings, earnings calls, dividend payouts',
  'Marketing': 'Campaigns (email, TV, site redesigns, social media)',
  'Research': 'Research projects and related initiatives',
  'Thought Leadership': 'Research projects and related initiatives',
  'Product': 'Product activity and fund launches',
  'Board': 'WTT, WTI, WTAM, WTE board meetings',
  'Internal Events': 'Events created by HR/Admin for employees (Town Halls, WIN, social events)',
  'WT Internal': 'Events created by HR/Admin for employees (Town Halls, WIN, social events)',
  'NYC Office': 'Events created by HR/Admin for employees (Town Halls, WIN, social events)',
  'Employee Events': 'Events created by HR/Admin for employees (Town Halls, WIN, social events)',
  'Office Closed': 'Office closures for public holidays',
};

const reactDropdownStyles = {
  control: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      // border: 0,
      // This line disable the blue border
      boxShadow: 0,
      fontSize: 13,
      color: '#5B6770',
      // '&:hover': {
      //   border: 0
      // }
    };
  },

  multiValue: (styles, { data }) => {
    const color = chroma(OUTLOOK_COLORS[data.color]);
    return {
      ...styles,
      backgroundColor: color.alpha(0.3).css(),
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: '#5B6770',
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: '#5B6770',
    ':hover': {
      backgroundColor: OUTLOOK_COLORS[data.color],
      color: 'white',
    },
  }),
  placeholder: () => ({
    color: '#BDC2C6',
  }),
  dropdownIndicator: () => ({
    color: '#596770',
    paddingTop: '4px',
  }),
  indicatorSeparator: () => null,
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {

    const color = chroma(OUTLOOK_COLORS[data.color]);
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
          ? color
          : isFocused
            ? color.alpha(0.3).css()
            : null,
      // backgroundColor: OUTLOOK_COLORS[data.color],
      marginTop: '0px',
      '&:hover': {
        color: '#596770',
        cursor: 'pointer'
      },
      '&:isSelected': {
        color: '#FFF'
      },
      '&:isFocused': {
        color: color
      },
    };
  },
};

class App extends PureComponent {

  constructor(props) {
    super(props);

    this.setEventColor = this.setEventColor.bind(this);
    this.handleSelectDropdown = this.handleSelectDropdown.bind(this);
    this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
    this.handleShowInfo = this.handleShowInfo.bind(this);
    this.handleCloseInfo = this.handleCloseInfo.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handleCloseEventInfo = this.handleCloseEventInfo.bind(this);

    this.state = {
      events: [],
      categories: [],
      filteredCategories: [],
      showEurope: true,
      showUS: true,
      showInfo: false,
      selectedEvent: null,
    };
    Calendar.tz = moment.tz.guess();
  }

  // Set up the state to have default values for the dynamically loaded inputs
  componentDidMount() {

    // Get the events
    this.getEvents();

    // Get the categories
    this.getCategories();

  }

  async getEvents() {

    const {
      params
    } = this.props;

    if (params.calendarUrl !== undefined) {

      // Get all the events from the O365 calendar
      const requestId = {
        method: 'GET',
        url: `${params.calendarUrl}`,
        params: {
          code: `${params.code}`,
        }
      };
      return axios(requestId)
        .then(d => {
          if (d.status === 404) {
            return;
          } else {
            return d.data;
          }
        })
        .then(data => {

          const newEvents = data.map(event => {

            // Solve for iOS converting from UTC to local - where all other OSs don't
            const startTokens = event.start.dateTime.split(/[-:T]/g);
            const startDateAllDate = new Date(startTokens[0], parseInt(startTokens[1], 10) - 1, startTokens[2]);

            const endTokens = event.end.dateTime.split(/[-:T]/g);
            const endDateAllDate = new Date(endTokens[0], parseInt(endTokens[1], 10) - 1, endTokens[2]);

            // Convert from UTC time to local for the non-all day events
            return {
              start: event.isAllDay ? startDateAllDate : new Date(moment.utc(event.start.dateTime).tz(TIMEZONE)),
              end: event.isAllDay ? endDateAllDate : new Date(moment.utc(event.end.dateTime).tz(TIMEZONE)),
              title: event.subject,
              toolTip: `${event.subject}\n\n${event.bodyPreview}`,
              allDay: event.isAllDay,
              category: event.categories.length > 0 ? event.categories[0] : null,
              body: event.bodyPreview,
              bodyFull: event.body ? event.body : null,
            };

          });

          this.setState({
            events: newEvents,
          });

        })
        .catch(error => {
          console.error(error);
        });

    }

  }

  // Get all the categories for a calendar
  async getCategories() {

    const {
      params
    } = this.props;

    if (params.categoriesUrl !== undefined) {

      // Get all the events from the O365 calendar
      const requestId = {
        method: 'GET',
        url: `${params.categoriesUrl}`,
        params: {
          code: `${params.code}`,
        }
      };
      return axios(requestId)
        .then(d => {
          if (d.status === 404) {
            return;
          } else {
            return d.data;
          }
        })
        .then(data => {

          // Get the category names for the dropdown
          const uniqueCategoryNames = data.map(category => {
            return {
              value: category.displayName,
              label: category.displayName,
              color: category.color,
            };
          });

          this.setState({
            categories: data,
            uniqueCategoryNames: uniqueCategoryNames,
          });

        })
        .catch(error => {
          console.error(error);
        });

    }

  }

  // Set the color of the Event depending on the category/subject
  setEventColor(event, start, end, isSelected) {

    const {
      categories,
    } = this.state;

    if (event.category && categories.length > 0) {
      const category = categories.filter(cat => cat.displayName === event.category);

      // If the category matches one from the master list then return the preset
      // color
      if (category.length > 0) {
        event.color = category[0].color;
        return {
          'className': category[0].color,
        };
      }
    }

  }

  // Handle events from the dropdown
  handleSelectDropdown(selectedCategories) {

    const categoriesToFilter = selectedCategories.map(category => {
      return category.value;
    });

    const difference = categoriesToFilter.filter(x => !this.state.filteredCategories.includes(x));

    ReactGA.event({
      category: 'Category Filter',
      action: difference.toString(),
    });

    // Set the filter categories
    this.setState({
      filteredCategories: categoriesToFilter,
    });
  }

  // Handle a User clicking on an event - pop out modal
  handleEventClick(event) {
    console.log(event);
    // Set the filter categories
    this.setState({
      selectedEvent: event,
    });
  }

  // Close the event info modal
  handleCloseEventInfo() {

    this.setState({
      selectedEvent: null,
    });
  }

  // Update the state with changes to checkbox inputs
  handleChangeCheckBox(name) {

    ReactGA.event({
      category: 'Region Filter',
      action: `${name}: ${!this.state[name]}`,
    });

    this.setState({
      [name]: !this.state[name],
    });
  }


  // Show the info modal
  handleShowInfo() {

    ReactGA.modalview('/info');
    ReactGA.event({
      category: 'Info',
      action: 'Show Legend',
    });

    this.setState({
      showInfo: true,
    });
  }

  // Close the info modal
  handleCloseInfo() {

    this.setState({
      showInfo: false,
    });
  }

  // Render the Information Modal
  renderInfoModal() {

    const {
      showInfo,
      categories,
    } = this.state;

    const infoContent = categories.map(category => {

      return <div className={Classnames('global-calendar', 'info-row')} key={category.displayName}>
        <div className={Classnames(category.color, 'info-category')}>
          {category.displayName}
        </div>
        <div className='info-description'>
          {CATEGORY_INFO[category.displayName]}
        </div>
      </div>;
    });

    return <Modal
      open={showInfo}
      onClose={this.handleCloseInfo}
      showCloseIcon={false}
      classNames={{ overlay: 'modal-overlay', modal: 'info-modal', closeIcon: 'custom-closeIcon' }}
      center
      closeIconSize={20}
    >
      <div className='info-content'>
        {infoContent}
      </div>
      <div className='close-button'>
        <div>
          <button
            onClick={this.handleCloseInfo}
          >
            CLOSE
          </button>
        </div>
      </div>
    </Modal>;
  }

  // Render the Event Modal
  renderEventModal() {

    const {
      selectedEvent,
    } = this.state;

    if (selectedEvent) {


      const timeDetails = selectedEvent.allDay === false?

        `${new Intl.DateTimeFormat('default', {
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        }).format(selectedEvent.start)} to ${new Intl.DateTimeFormat('default', {
          hour: '2-digit',
          minute: '2-digit',
        }).format(selectedEvent.end)}`
        : `${new Intl.DateTimeFormat('default', {
          month: 'short',
          day: '2-digit',
        }).format(selectedEvent.start)}`;

      console.log(selectedEvent);
      return (
        <Modal
          open={selectedEvent ? true : false}
          onClose={this.handleCloseEventInfo}
          showCloseIcon={false}
          classNames={{ overlay: 'modal-overlay', modal: 'info-modal', closeIcon: 'custom-closeIcon' }}
          center
          closeIconSize={20}
        >
          <div className='event-content global-calendar'>
            <div className={Classnames('info-category',selectedEvent.color)} >
              <div className='info-title'>{selectedEvent.title}</div>
              <div className='info-time'>{timeDetails}</div>
            </div>
            <div className='event-body'>
              <Linkify
                componentDecorator={componentDecorator}>
                  <div className='event-inner-body' dangerouslySetInnerHTML={{__html: selectedEvent.bodyFull.content}}></div>
              </Linkify>
            </div>
           
          </div>
          <div className='close-button'>
            <div>
              <button
                onClick={this.handleCloseEventInfo}
              >
                CLOSE
              </button>
            </div>
          </div>
        </Modal>
      );

    } else {
      return null;
    }
  }

  // Build custom renderer for the Agenda events
  renderEventAgenda({ event }) {
    return (
      <div>
        <strong>{event.title}</strong>
        {event.body ? 
          <div className='event-agenda'>
            <Linkify
            componentDecorator={componentDecorator}>
              <div className='event-body' dangerouslySetInnerHTML={{__html: event.bodyFull.content}}></div>
            </Linkify>
          </div>
        : null}
      </div>
    )
  }

  render() {

    const {
      uniqueCategoryNames,
      events,
      filteredCategories,
      showEurope,
      showUS,
    } = this.state;


    // Filter the events by the categories and the regional check boxes
    let filteredEvents = events;

    filteredEvents = events.filter(event => {

      // Check for category filters
      if (filteredCategories.length > 0 && filteredCategories.indexOf(event.category) < 0) {
        return false;
      }

      // Check for regional filters
      if (showEurope === false && event.title.indexOf(EUROPE) >= 0) {
        return false;
      }
      if (showUS === false && event.title.indexOf(US) >= 0) {
        return false;
      }

      return true;

    });

    const {
      params
    } = this.props;

    const formats = {

      agendaHeaderFormat: ({
        start,
        end
      }, culture, local) =>
        local.format(start, 'MMM DD', culture) + ' – ' +
        local.format(end, 'MMM DD', culture),

      monthHeaderFormat: 'MMM YYYY',

      dayRangeHeaderFormat: ({
        start,
        end
      }, culture, local) =>
        local.format(start, 'MMM DD', culture) + ' – ' +
        local.format(end, 'MMM DD', culture),

    };

    // Set up the overrides for text
    const messages = {
      work_week: 'WEEK',
    };

    // Set height and width for the container
    const height = params.height ? params.height : '90vh';
    const width = params.width ? params.width : '100%';

    const widthStyle = {
      maxWidth: width,
    };

    const infoModal = this.renderInfoModal();
    const eventInfoModal = this.renderEventModal();

    return (
      <div className='app' style={widthStyle}>

        <div className='input-row'>

          {/* Regional filter labels  */}
          <div className='region-filter'>
            <div className='region'>
              <label>
                <Checkbox
                  checked={showUS}
                  onChange={this.handleChangeCheckBox.bind(this, 'showUS')}
                />
                &nbsp; US
              </label>
            </div>
            <div className='region'>
              <label>
                <Checkbox
                  checked={showEurope}
                  onChange={this.handleChangeCheckBox.bind(this, 'showEurope')}
                />
                &nbsp; Europe
              </label>
            </div>
          </div>

          <div className='category-filter'>
            <Select
              className={Classnames('dropdown')}
              placeholder='All Events'
              onChange={selectedItem => {
                this.handleSelectDropdown(selectedItem);
              }
              }
              styles={reactDropdownStyles}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  primary25: '#05A9B1',
                  primary: '#05A9B1',
                },
                opacity: 0.2,
              })}
              options={uniqueCategoryNames}
              isMulti={true}
            />
            <div
              className='info-icon'
              onClick={this.handleShowInfo}
            >
              <FontAwesomeIcon icon='info-circle' size='2x' />
            </div>
          </div>

        </div>

        <div className='global-calendar'>
          <Calendar
            localizer={localizer}
            defaultDate={new Date()}
            defaultView='month'
            events={filteredEvents}
            style={{ height: height }}
            tooltipAccessor='toolTip'
            eventPropGetter={this.setEventColor}
            onSelectSlot={null}
            onSelectEvent={this.handleEventClick}
            views={['month', 'work_week', 'agenda']}
            drilldownView='agenda'
            formats={formats}
            messages={messages}
            components={{
              agenda: {
                event: this.renderEventAgenda,
              },
            }}
          />

        </div>

        {/* Show the info Modals */}
        {infoModal}
        {eventInfoModal}

      </div>
    );
  }
}

export default (App);
